import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "passing-arguments"
    }}>{`Passing Arguments`}</h1>
    <p>{`Since InDesign v18.4 arguments/parameters can be passed to UXP scripts. `}</p>
    <p>{`You can use the `}<inlineCode parentName="p">{`script.args`}</inlineCode>{` API to access the arguments passed to the script as an array.`}</p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <p>{`Use the following to fetch the arguments passed to the script as an array:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const script = require("uxp").script;
let argsArray = script.args
`}</code></pre>
    <InlineAlert variant="info" slots="text1" mdxType="InlineAlert" />
Arguments cannot be passed from the InDesign application directly. We can pass arguments to a script directly using InDesign Server only. 
    <h2 {...{
      "id": "passing-arguments-to-indesign-server"
    }}>{`Passing Arguments to InDesign Server`}</h2>
    <p>{`You can pass arguments to InDesign Server through the `}<inlineCode parentName="p">{`sampleclient`}</inlineCode>{`. `}</p>
    <p>{`Specify all the necessary information, such as the port number, script name, and arguments. Pass the arguments as a string where the `}<inlineCode parentName="p">{`=`}</inlineCode>{` sign separates the key and the value. The `}<inlineCode parentName="p">{`script.args`}</inlineCode>{` API returns an array of strings where the elements are the key/value pairs of arguments specified while executing the script. Here’s an example:`}</p>
    <p><strong parentName="p">{`Command to Pass Arguments to IDS Scripts`}</strong></p>
    <pre><code parentName="pre" {...{}}>{`../../../../mac/debug_cocoa64/sampleclient -host localhost:12345 testArgs.idjs "arg1=100" "arg2=200"
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const script = require("uxp").script;
let ar = script.args;
script.setResult(ar);
`}</code></pre>
    <p>{`The result after executing this script on InDesign Server is shown on the client side. `}</p>
    <pre><code parentName="pre" {...{}}>{`Script result (LIST, 2):
    (std__string): arg1=100
    (std__string): arg2=200
`}</code></pre>
    <h2 {...{
      "id": "passing-arguments-to-indesign-server-indesign-app-via-doscript"
    }}>{`Passing Arguments to InDesign Server/ InDesign App Via doScript()`}</h2>
    <p>{`Passing arguments to another UXP script is possible with the help of the `}<inlineCode parentName="p">{`doScript`}</inlineCode>{` API. `}</p>
    <p>{`You can pass a variable of type array as the third parameter of the doScript API call. Unlike on InDesign Server, `}<inlineCode parentName="p">{`script.args`}</inlineCode>{` fetches the values of the arguments passed to the external script. Here’s an example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`//caller.idjs
const myInDesign = require("indesign");
const app = myInDesign.app;
const argsArray = [100,200];
app.doScript("PATH_TO_CALLED/called.idjs", myInDesign.ScriptLanguage.UXPSCRIPT, argsArray);
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`//called.idjs
const script = require("uxp").script;
consoel.log(script.args);
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`[console] 100,200
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      